export enum AcceptanceState {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
  SYSTEM = "SYSTEM",
}
